module.exports = __webpack_public_path__ + "img/013.96ea08fa.svg";